import React from 'react';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import Header from './Header';
import SummaryTandC from './Summary';
import Liability from './Liability';
import Payment from './Payment';
// import IntellectualProperty from './Property';
import Services from './Services';
import Termination from './Termination';
import Acceptance from './Acceptance';
import Content from './Content';
import Prohibited from './Prohibited';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
const TermsAndConditions = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Terms and Conditions"
        description="Read our Terms and Conditions for information about using our website, online training services, purchases, accounts, and other applicable terms."
      />
      <SideContainerComponent />
      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Terms & Conditions" />
        <PageHeader
          eyebrow="Legal"
          title="Terms and Conditions"
          desc="Review the terms and conditions related to the use of our platform and services."
        />
        <Header />
        <Services />
        <Acceptance />
        <Content />
        <Prohibited />
        {/* <ContentProperty /> */}
        <Termination />
        <Payment />
        {/* <IntellectualProperty /> */}
        <Liability />
        <SummaryTandC />
      </MainSection>
    </MainContentContainer>
  );
};

export default TermsAndConditions;
